/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {useState} from 'react';
import {Box, Grid} from '@mui/material';
import './ApplyClaimModal.css';
import CustomModal from '../../CustomModal/CustomModal';
import ModalFooter from '../../CustomModal/ModalFooter';
import ModalHeader from '../../CustomModal/ModalHeader';
import CustomTextField from '../../../components/CustomTextField/CustomTextField';
import * as _ from 'lodash';
import CustomAutoComplete from '../../../components/CustomAutoComplete/CustomAutoComplete';
import CompDirection from '../../../themes/CompDirection';
import DropAndSelect from '../../../components/DropAndSelect/DropAndSelect';
import {DatePickerInput} from '../../../../components';

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  allClaimTypes: any;
  callBackGetData: (data: any) => void;
  trans?: any;
}

const ApplyClaimModalPresenter = ({
  isModalOpen,
  closeModal,
  callBackGetData,
  allClaimTypes,
  trans,
}: ModalProps) => {
  const [remarks, setRemarks] = useState('');
  const [amount, setAmount] = useState();
  const [claimTypeName, setClaimTypeName] = useState('');
  const [claimTypeId, setClaimTypeId] = useState(0);
  const [startDate, setStartDate] = useState<any>(new Date());
  const [claimDocumentFile, setClaimDocumentFile] = useState('');
  const [claimDocumentFilePath, setClaimDocumentFilePath] = useState('');
  const [isPDF, setIsPDF] = useState<boolean>(false);
  const [pdfName, setPDFName] = useState('');
  const [newattachement, setNewAttachement] = useState(false);

  const handleSetClaimType = (claimName: any) => {
    const getClaim = _.filter(allClaimTypes, function (claim: any) {
      return claim.name === claimName;
    });
    if (getClaim.length) {
      const claim_type = getClaim[0];
      setClaimTypeId(claim_type.id);
      setClaimTypeName(claimName);
    }
  };

  const claimDocumentUpload = (e: any) => {
    const _file = e.target.files[0];
    setNewAttachement(true);
    if (_file?.type.includes('image')) {
      const image_as_base64 = URL.createObjectURL(e.target.files[0]);
      setClaimDocumentFile(_file);
      setClaimDocumentFilePath(image_as_base64);
    } else {
      setClaimDocumentFile(_file);
      setClaimDocumentFilePath('');
      setIsPDF(true);
      setPDFName(_file?.name);
    }
  };

  const handleSubmit = () => {
    callBackGetData({
      claim_type_id: claimTypeId,
      remarks: remarks,
      amount: amount,
      startDate: startDate,
      attachment: claimDocumentFile,
      newattachement: newattachement,
    });
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="755px"
      modalWidth="650px"
    >
      <ModalHeader
        modal={{ modal_title: trans('Apply Claim') }}
        closeModal={closeModal}
      />
      <CompDirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: '5px',
          }}
        >
          <Grid item xs={6}>
            <CustomAutoComplete
              label={trans('Claim Type')}
              options={_.map(allClaimTypes, (claim: any) => {
                return claim.name;
              })}
              value={claimTypeName}
              onChange={(event: any, newValue: any) => {
                handleSetClaimType(newValue);
              }}
            />
          </Grid>

          <Grid item xs={6}>
            <DatePickerInput
              value={new Date(startDate)}
              label={trans('Start Date')}
              width="100%"
              onChange={(newValue: any) => {
                setStartDate(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <CustomTextField
              type="number"
              label={trans('Amount')}
              placeholder={trans('Write Amount')}
              value={amount}
              onChange={(e: any) => setAmount(e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <CustomTextField
              type="string"
              label={trans('Remarks')}
              placeholder={trans('Write Remarks')}
              value={remarks}
              onChange={(e: any) => setRemarks(e.target.value)}
            />
          </Grid>

          <Grid item xs={6}>
            <DropAndSelect
              upload={claimDocumentUpload}
              src={claimDocumentFilePath}
              isPDF={isPDF}
              pdfName={pdfName}
              onDelete={() => {
                setIsPDF(false);
                setPDFName('');
                setClaimDocumentFilePath('');
                setNewAttachement(false);
              }}
            />
          </Grid>
        </Grid>
      </CompDirection>

      <Box style={{ marginTop: '35px' }} />
      <ModalFooter
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};

export default ApplyClaimModalPresenter;
